interface GameLoadingProps {
  count: number;
}

export const GameLoading = ({ count }: GameLoadingProps) => {
  return (
    <>
      {Array.from(Array(count), (_, index) => (
        <div className="animated-background" key={index}></div>
      ))}
    </>
  );
};
